import './App.css';
import {useEffect, useState} from "react";
import axios from "axios";
import {Oval} from "react-loader-spinner";

function App() {
    const baseApiUrl = "https://swipeflow-api.maik.software"
    const [activeSession, setActiveSession] = useState(undefined);
    const [captchaUrl, setCaptchaUrl] = useState("");
    const [captcha, setCaptcha] = useState("");
    const [jobDescription, setJobDescription] = useState("");
    const [perimeter, setPerimeter] = useState(20);
    const [isLoading, setIsLoading] = useState(false);

    const [angebotsart, setAngebotsart] = useState('Arbeit');

    const handleChange = (event) => {
        setAngebotsart(event.target.value);
    };

    useEffect(() => {
        axios.get(`${baseApiUrl}/active-session`).then(response => {
            if (response.data === null) {
                setActiveSession(false);
                return;
            }

            setActiveSession(true)
            setCaptchaUrl(response.data.current_captcha_url)
        })
    }, [])

    const startNewSession = () => {
        setIsLoading(true)
        axios.post(`${baseApiUrl}/start-new-session`, {
            "job_description": jobDescription,
            "angebotsart": angebotsart,
            "perimeter": perimeter
        }).then(response => {
            setActiveSession(true)
            setCaptchaUrl(response.data.captcha_url)
            setIsLoading(false)
        })
    }

    function b64DecodeUnicode(str) {
        return decodeURIComponent(atob(str).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }


    const downloadFile = () => {
        axios.get(`${baseApiUrl}/file`).then(response => {
            const encodedFile = b64DecodeUnicode(response.data.file);
            const blob = new Blob([encodedFile], {type: "text/csv"});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'leads.csv';
            link.click();
        })
    }

    const enterCaptcha = () => {
        if (captcha.length !== 6) {
            return;
        }

        setIsLoading(true)

        const body = {
            "captcha": captcha
        }

        axios.post(`${baseApiUrl}/enter-captcha-code`, body).then(response => {
            if (response.data.captcha) {
                setCaptchaUrl(response.data.captcha)
                setCaptcha("")
                setIsLoading(false)
                return;
            }

            downloadFile()

            setCaptchaUrl("")
            setCaptcha("")
            setIsLoading(false)
            setActiveSession(false)
        })
    }

    const abortSession = () => {
        axios.post(`${baseApiUrl}/abort-session`).then(response => {
            setCaptchaUrl("")
            setCaptcha("")
            setIsLoading(false)
            setActiveSession(false)
        })
    }

    const handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            enterCaptcha();
        }
    }

    const handleKeyPressNew = (event) => {
        if(event.key === 'Enter'){
            startNewSession();
        }
    }

    return (
        <div className="App">
            <div className="App-header">
                {isLoading && (
                    <Oval visible={true} color="#ffffff"/>
                )}
                {(activeSession === true && !isLoading) && (
                    <div>
                        {captchaUrl && (
                            <div>
                                <div>
                                    <img src={captchaUrl} alt="hier muss ein Captcha stehen"/>
                                </div>
                                <div>
                                    <input type="text" value={captcha} onChange={e => setCaptcha(e.target.value)}></input>
                                    <button onClick={enterCaptcha} onKeyUp={handleKeyPress}>Absenden</button>
                                </div>
                            </div>
                        )}

                        <div>
                            <button className="abort" onClick={abortSession}>Abbrechen</button>
                        </div>
                    </div>
                )}

                {(activeSession === false && !isLoading) && (
                    <div>
                        <label>Job-Bezeichnung:</label>
                        <input type="text" value={jobDescription} onChange={e => setJobDescription(e.target.value)}></input>
                        <label>Umkreis:</label>
                        <input type="number" value={perimeter} onChange={e => setPerimeter(e.target.value)}></input>
                        <label>Art:</label>
                        <label>
                            <input
                                type="radio"
                                name="angebotsart"
                                value="Arbeit"
                                checked={angebotsart === 'Arbeit'}
                                onChange={handleChange} /> Arbeit
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="angebotsart"
                                value="Ausbildung"
                                checked={angebotsart === 'Ausbildung'}
                                onChange={handleChange} /> Ausbildung
                        </label>
                        <button className="button" onClick={startNewSession} onKeyUp={handleKeyPressNew}>Starte neue Session</button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default App;
